import { ComponentPropsWithoutRef, forwardRef } from 'react';
import { Card as CardPrimitive, Slot, styled, Text } from '@streamelements/frontend-ui';

const StyledCard = styled(CardPrimitive.Root, {
  border: '1px solid $divider',
  borderRadius: '0.25rem',
  textAlign: 'start',
  textDecoration: 'none',

  variants: {
    density: {
      default: {
        padding: '1rem',
      },
      compact: {
        padding: '0.5rem 0.75rem',
      },
    },
  },

  defaultVariants: {
    density: 'default',
  },
});

export const Card = forwardRef<HTMLDivElement, ComponentPropsWithoutRef<typeof StyledCard> & { asChild?: boolean }>(
  function Card({ asChild, ...props }, ref) {
    return <StyledCard {...props} ref={ref} as={asChild ? Slot : undefined} />;
  }
);

const StyledCardHeader = styled(CardPrimitive.Header, {
  margin: 0,
  padding: 0,
  lineHeight: 1.5,
  variants: {
    size: {
      default: {},
      sm: {
        fontSize: '$caption',
      },
      md: {
        fontSize: '$body',
      },
    },
  },
});

export const CardHeader = forwardRef<
  HTMLHeadingElement,
  ComponentPropsWithoutRef<typeof StyledCardHeader> & { asChild?: boolean }
>(function CardHeader({ asChild, ...props }, ref) {
  return (
    <StyledCardHeader {...props} as={Slot} ref={ref}>
      <Text.Subtitle weight="bold" ref={ref} as={asChild ? Slot : undefined}>
        {props.children}
      </Text.Subtitle>
    </StyledCardHeader>
  );
});
